import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';
import { IdocumentationService, IUploadService } from '../../../services';

class AutoGeneratedController implements angular.IComponentController {

    documentation: string;
    isLoading: boolean;
    loadingMessage: string;

    static $inject = ['documentationService', 'uploadService'];

    constructor(
        private _documentationService: IdocumentationService,
        private _uploadService: IUploadService
    ) {
    }

    $onInit() {
        this.refresh();
    }

    download() {
        return this._uploadService.download(this.documentation, 'documentation.md', 'text/plain');
    }

    refresh() {
        this.isLoading = true;
        this._documentationService.getDocumentation()
            .then(data => {
                this.documentation = data;
            })
            .finally(() => this.isLoading = false);
    }
}

export const wtAutoGenerated: ComponentDefinition = {
    componentId: 'wtAutoGenerated',
    controller: AutoGeneratedController,
    template: require('./autoGenerated.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
